import { Breadcrumbs, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { isSettingPage } from 'utils/location';
import { useNavigate, useLocation } from 'react-router-dom';
import GVIconButton from 'components/lib/GVIconButton/GVIconButton';
import AddTeamMember from './myTeam/AddTeamMember';
import CreateOrganization from './tenantManagement/CreateOrganization';
import AddDictionary from './customDictionaries/AddDictionary';
import { DictionaryHeader } from './customDictionaries/DictionaryHeader';
import { useEffect } from 'react';
import { useCustomDictionaryStore } from './customDictionaries/store';
import styles from './Header.module.css';

interface MyAccountHeaderProps {
  title: string;
  breadcrumbs: string[];
  showAddMember: boolean;
  showAddTenant: boolean;
  showAddDictionary: boolean;
  showCustomStatuses: boolean;
}

const Header = (props: MyAccountHeaderProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { activeCustomDictionaryId, setActiveCustomDictionaryId } = useCustomDictionaryStore();

  const handleBackArrow = () => {
    if (activeCustomDictionaryId) {
      setActiveCustomDictionaryId(null);
    } else navigate('/myaccount/settings');
  };

  // Reset active dictionary if user navigates away from custom dictionaries
  useEffect(() => {
    if (!location.pathname.includes('customdictionaries')) {
      setActiveCustomDictionaryId(null);
    }
  }, [location.pathname]);

  return (
    <>
      <div className={styles.root}>
        {!isSettingPage(location) && (
          <GVIconButton
            onClick={handleBackArrow}
            color="primary"
            className={styles.button}
            data-testid="my_account_back_button"
            icon={<ArrowBackIcon />}
          />
        )}
        <div className={styles.text}>
          <Breadcrumbs separator={<NavigateNextIcon fontSize="small" color="primary" />} aria-label="breadcrumb">
            {props.breadcrumbs.map((breadcrumb) => {
              return (
                <Typography key={breadcrumb} id={`${breadcrumb}-breadcrumb`} className={styles.breadcrumbs}>
                  {breadcrumb}
                </Typography>
              );
            })}
          </Breadcrumbs>
          {activeCustomDictionaryId ? (
            <DictionaryHeader />
          ) : (
            <Typography variant="h4" className={styles.title}>
              {props.title}
            </Typography>
          )}
        </div>
        {props.showAddTenant && (
          <div className={styles.actions}>
            <CreateOrganization />
          </div>
        )}
        {props.showAddDictionary && <AddDictionary />}
      </div>
      {props.showAddMember && <AddTeamMember />}
    </>
  );
};

export default Header;
